/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import { getCustomerName } from '../../lib/customer.mjs'
import { fetchCustomer } from '../../lib/rest/customerAPIClient'
import CustomerForm from './CustomerForm'
import { useQuery } from '@tanstack/react-query'
import LoadingHelper from '../../../../client/js/components/LoadingHelper'
import { Card, Container } from '@mantine/core'
import Page from '../../../../client/js/components/Page'
import CustomerBreadcrumb from './CustomerBreadcrumb'

function CustomerFormPage () {
  const intl = useIntl()
  const params = useParams<{ id?: string }>()
  const customerId = parseInt(params.id, 10)

  const customerQuery = useQuery({
    enabled: true,
    queryKey: ['customer', customerId],
    queryFn: () => customerId > 0
      ? fetchCustomer(customerId)
      : Promise.resolve({} as Partial<Customer>),
    refetchOnWindowFocus: false
  })
  const { data } = customerQuery

  const title = customerId > 0 && data != null
    ? getCustomerName(data)
    : intl.formatMessage({
      id: 'create_contact',
      defaultMessage: 'Créer un contact'
    })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <CustomerBreadcrumb
          customer={customerQuery.data}
          title={title}
        />

        <Card shadow="sm">
          <LoadingHelper
            query={customerQuery}
            render={() => (
              <CustomerForm initialValues={data} />
            )}
          />
        </Card>
      </Container>
    </Page>
  )
}

export default CustomerFormPage
